<template>
    <div class="cz2__steps-option cz2__steps-options__shared">
        <step-header
            :hasSubMenu="false"
            :showSubMenuTitle="true"
            :subMenuTitle="canBuyPop ? `${price} ${$t('EACH')}` : null"
            :showColorSwatches="false"
            :hasPrice="true"
        />

        <swiper
            topQuerySelector=".cz2__pet"
            selectedQuerySelector=".selection-card--selected"
            class="cz2__steps-options__list-wrapper"
        >
            <pets
                @updateNavigation="updateNavigation"
                :pet="pet"
                :currency="currency"
                @add="addPet"
            />
        </swiper>
    </div>
</template>

<script>
    import Swiper from './ui/Swiper.vue';
    import StepHeader from './ui/StepHeader.vue';
    import Pets from './Pets.vue';

    import * as constants from '../constants';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        components: {
            StepHeader,
            Pets,
            Swiper,
        },

        data() {
            return {
                // TODO: Should be configured by e-comm.
                currency: 'USD',
                pet: null,
            };
        },

        computed: {
            options() {
                return this.$store.state.customizer.options;
            },

            canBuyPop() {
                return this.options && this.options.canBuyPop;
            },

            viewController() {
                return this.$store.state.customizer.viewController;
            },

            allPets() {
                return this.$store.getters.pets;
            },

            price() {
                const firstAvailablePet = this.getFirstAvailablePet();

                return formatPrice(this.$store.state, firstAvailablePet?.price, 'compact');
            },
        },

        methods: {
            updateNavigation(navRules) {
                this.$emit('updateNavigation', {
                    ...navRules,
                    hasNext: true,
                    canGoNext: true,
                });
            },

            addPet(pet) {
                const toAdd = pet || this.pet;

                // Check if we already know about this one.
                let added = false;

                this.viewController.state.forEach((s) => {
                    if (s.placement.code === constants.PLACEMENT_PET_PREVIEW) {
                        return;
                    }

                    if (s.placement.code === constants.PLACEMENT_PET_PREVIEW_SECONDARY) {
                        return;
                    }

                    if (s.component.placementIndependentCode === toAdd.placementIndependentCode) {
                        if (this.viewController.isAvailable(s.component, s.component.quantityMultiplier + 1)) {
                            this.$store.dispatch('bumpVersion');

                            this.$store.dispatch('removeAlertFromPlacement', s.placement.code);

                            this.$store.dispatch('setComponentQuantity', {
                                component: s.component,
                                quantity: s.component.quantityMultiplier + 1,
                            });

                            this.$store.dispatch('syncPets');
                        }

                        added = true;
                    }
                });

                if (!added) {
                    let firstFree = null;

                    this.viewController.state.forEach((s) => {
                        if (constants.PLACEMENT_PETS.includes(s.placement.code)) {
                            if (s.component.placeholder) {
                                if (firstFree == null) {
                                    firstFree = s.placement;
                                }
                            }
                        }
                    });

                    if (firstFree) {
                        const select = firstFree.components.find((c) => c.placementIndependentCode === toAdd.placementIndependentCode
                            && this.viewController.isAvailable(c));

                        if (select) {
                            this.$store.dispatch('bumpVersion');

                            this.$store.dispatch('removeAlertFromPlacement', firstFree.code);

                            this.viewController.updateComponent(firstFree.code, select.code);

                            const setQuantity = this.viewController.selectedAtPlacement(firstFree.code);

                            this.$store.dispatch('setComponentQuantity', {
                                component: setQuantity,
                                quantity: 1,
                            });

                            this.$store.dispatch('syncPets');
                        }
                    }
                }

                this.pet = null;
            },

            formatPriceValue(price) {
                return formatPrice(this.$store.state, price, 'standard');
            },

            // Make sure pet is in stock and has a price
            getFirstAvailablePet() {
                // Was: canAdd. But, we need justa price, we don't need to check if we can actually add it.
                // Otherwise the page with preselected pets would say NAN.
                // const firstAvailablePet = this.allPets.find((x) => x.canAdd && x.price !== 0);

                const firstAvailablePet = this.allPets.find((x) => x.price != null && x.price !== 'FREE' && x.price !== 0);

                return firstAvailablePet;
            },
        },
    };
</script>
